import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

require('./lib/featherlight.min.js');


import { setAlerts } from './alerts.js';
import { faq } from './utils/faq';
import { inpageNav } from './utils/inpageNav';
import { forms } from './utils/forms';
import { sharePopup } from './utils/share';

(function() {
  'use strict';

  // Init
  setAlerts();
  faq();
  sharePopup();
  forms();

  // search modal close button
  $('.search-button').featherlight('', {
    closeIcon:
      '<span class=\'svg js-svg-fallback svg-inline icon-icon_x\' data-filename=\'icon_x\'><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"><path fill="#AF1C2E" fill-rule="evenodd" d="M9 7.5l-3-3 3-3L7.5 0l-3 3-3-3L0 1.5l3 3-3 3L1.5 9l3-3 3 3z"/></svg></span> Close'
  });

  $(document).ready(function() {
    $('.search-button').click(function() {
      $('.searchModal input').focus();
    });

    if ($('.C21').not('.pseudo-tabs').length) {
      inpageNav();
    }

    // Main Navigation -------------------------
    // cache jquery elements
    let $header = $('.js-header'),
      $mobileNavToggle = $('.js-mobile-nav-toggle, .js-mobile-search-toggle'),
      $navContainers = $('.js-mobile-nav-background, .js-mobile-nav-container'),
      $mobileNav = $('.js-mobile-nav'),
        $navLinks = $('.primary-nav a, .js-mobile-nav a');

    // Active nav item(s)
    if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
          start = 0;
        }
    
        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      };
    }
    let windowUrl = window.craft.absoluteUrl;
    $navLinks.each(function(){
      if(this.href !== "" && windowUrl.includes(this.href)) {
        $(this).addClass('active').parents('li').addClass('active');
      }
    });

    // Toggle Mobile Nav Open/Close
    $mobileNavToggle.click(function() {
      $navContainers.toggleClass('open');
      $('body').toggleClass('overflow-hidden');
    });

    $('.js-mobile-search-toggle').click(function() {
      setTimeout(function() {
        $('.mobile-search input').focus();
      }, 500);
    });

    // close menu on background click
    $('.js-mobile-nav-background').on('click', function(e) {
      if (e.target !== this) return;
      $navContainers.toggleClass('open');
      $('body').toggleClass('overflow-hidden');
    });

    // Toggle Sub-Menus in Mobile Nav
    $mobileNav.find('a.dropdown-toggle').click(function(e) {
      e.preventDefault();
      $(this)
        .parent('li')
        .toggleClass('open');
    });

    // ------------------------- Main Navigation

    // bind last two words in copy blocks to prevent orphans
    $('.C13-copy').each(function() {
      var string = $(this).html();
      string = string.replace(/ ([^ ]*)$/, '&nbsp;$1');
      $(this).html(string);
    });

    // Get a Quote Modals
    $('a[href~="#request-a-quote"]').featherlight({
      iframe: '/request-a-quote',
      iframeMaxWidth: '100%',
      iframeWidth: '100%',
      iframeHeight: 600,
      variant: 'request-a-quote-modal'
    });


  });
})();



// WEBPACK FOOTER //
// ./resources/js/index-shred.js